// extracted by mini-css-extract-plugin
module.exports = {"container":"Section2_container__2ZAq7","items":"Section2_items__2XLgg"};